export const orgCardShadow = '2px 4px 4px 0px rgba(204, 204, 204, 0.25)';

export const orgCardRadius = 8;

export const orgPageMaxWidth = 1200;

export const orgFormMaxWidth = 640;

export const orgFormNarrowMaxWidth = 520;

export const orgHeroGradient =
  'linear-gradient(135deg, #ffffff 0%, #f8fafc 58%, #eff6ff 100%)';

export const orgBrandBlue = '#175cd3';
export const orgBrandGreen = '#027a48';

export const orgPrimaryActionButtonClassName = 'farm-onboarding-action-button';

export const orgPrimaryButtonStyle = {
  backgroundColor: '#4a4d4e',
  borderColor: '#4a4d4e',
};

export const orgActionButtonStyle = {
  height: 46,
  borderRadius: 12,
  fontWeight: 600,
};

export const orgFormPanelStyle = {
  background: '#fff',
  borderRadius: orgCardRadius,
  boxShadow: orgCardShadow,
  padding: '28px 24px',
};
